function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { forwardRef } from 'react';
import IconEditSolidIcon from '~icons/clarity/edit-solid';
import { su, theme } from '@arc/frontend/ui-theme';
export const editIconActiveStyle = /*#__PURE__*/css({
  border: 'none',
  backgroundColor: theme.colors.palettes.primary.main,
  color: theme.colors.white
}, process.env.NODE_ENV === "production" ? "" : ";label:editIconActiveStyle;");
const styles = {
  container: /*#__PURE__*/css(su.roundedFull, {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderColor: theme.colors.palettes.primary.main,
    borderWidth: '1px',
    width: '26px',
    height: '26px',
    minWidth: '26px',
    backgroundColor: theme.colors.white,
    color: theme.colors.palettes.primary.main,
    '&:hover:not([data-disabled=true])': editIconActiveStyle,
    '&[data-disabled=true]': {
      cursor: 'default',
      color: theme.colors.action.disabledBackground,
      borderColor: theme.colors.action.disabledBackground
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:container;"),
  menuContainer: /*#__PURE__*/css(su.roundedFull, {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderColor: theme.colors.palettes.primary.main,
    borderWidth: '1px',
    width: '22px',
    height: '22px',
    color: theme.colors.palettes.primary.main,
    '&:hover:not([data-disabled=true])': {
      color: theme.colors.palettes.primary.dark
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:menuContainer;"),
  icon: process.env.NODE_ENV === "production" ? {
    name: "157xhr7",
    styles: "width:16px;height:16px"
  } : {
    name: "6o636l-icon",
    styles: "width:16px;height:16px;label:icon;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};

// eslint-disable-next-line @typescript-eslint/no-shadow
export const EditIcon = forwardRef(function EditIcon({
  Icon = IconEditSolidIcon,
  isMenu,
  ...props
}, ref) {
  return <div css={isMenu ? styles.menuContainer : styles.container} data-cy="edit-icon" data-testid="edit-icon" {...props} ref={ref}>
			<Icon css={styles.icon} />
		</div>;
});